export default __webpack_public_path__ + "static/media/home-interior-design-blog-img02.5839a4f2.jpg";